import hoistNonReactStatics from './HoistNonReactStatics';
import warning from 'warning';
import { isMemo } from 'react-is';

function getDisplayName(WrappedComponent: any) {
    return WrappedComponent.displayName || WrappedComponent.name || 'WrappedComponent';
}

export function argumentContainer(Container: any, WrappedComponent: any) {
    /* eslint no-param-reassign:0 */
    Container.displayName = `Form(${getDisplayName(WrappedComponent)})`;
    Container.WrappedComponent = WrappedComponent;
    return hoistNonReactStatics(Container, WrappedComponent);
}

export function identity(obj: any) {
    return obj;
}

export function flattenArray(arr: any[]) {
    return Array.prototype.concat.apply([], arr);
}

export function treeTraverse(
    path = '',
    tree: any,
    isLeafNode: any,
    errorMessage: any,
    callback: any
) {
    if (isLeafNode(path, tree)) {
        callback(path, tree);
    } else if (tree === undefined || tree === null) {
    // Do nothing
    } else if (Array.isArray(tree)) {
        tree.forEach((subTree, index) =>
            treeTraverse(`${path}[${index}]`, subTree, isLeafNode, errorMessage, callback)
        );
    } else {
    // It's object and not a leaf node
        if (typeof tree !== 'object') {
            warning(false, errorMessage);
            return;
        }
        Object.keys(tree).forEach((subTreeKey) => {
            const subTree = tree[subTreeKey];
            treeTraverse(
        `${path}${path ? '.' : ''}${subTreeKey}`,
        subTree,
        isLeafNode,
        errorMessage,
        callback
            );
        });
    }
}

export function flattenFields(maybeNestedFields: any, isLeafNode: any, errorMessage: any) {
    const fields: any = {};
    treeTraverse(undefined, maybeNestedFields, isLeafNode, errorMessage, (path: string, node: any) => {
        fields[path] = node;
    });
    return fields;
}

export function normalizeValidateRules(validate: any[], rules: any, validateTrigger: any) {
    const validateRules = validate.map((item) => {
        const newItem = {
            ...item,
            trigger: item.trigger || [],
        };
        if (typeof newItem.trigger === 'string') {
            newItem.trigger = [newItem.trigger];
        }
        return newItem;
    });
    if (rules) {
        validateRules.push({
            trigger: validateTrigger ? [].concat(validateTrigger) : [],
            rules,
        });
    }
    return validateRules;
}

export function getValidateTriggers(validateRules: any[]) {
    return validateRules
        .filter((item) => !!item.rules && item.rules.length)
        .map((item) => item.trigger)
        .reduce((pre, curr) => pre.concat(curr), []);
}

export function getValueFromEvent(e: any) {
    // To support custom element
    if (!e || !e.target) {
        return e;
    }
    const { target } = e;
    return target.type === 'checkbox' ? target.checked : target.value;
}

export function getErrorStrs(errors: any) {
    if (errors) {
        return errors.map((e: any) => {
            if (e && e.message) {
                return e.message;
            }
            return e;
        });
    }
    return errors;
}

export function getParams(ns: any, opt: any, cb: any) {
    let names = ns;
    let options = opt;
    let callback = cb;
    if (cb === undefined) {
        if (typeof names === 'function') {
            callback = names;
            options = {};
            names = undefined;
        } else if (Array.isArray(names)) {
            if (typeof options === 'function') {
                callback = options;
                options = {};
            } else {
                options = options || {};
            }
        } else {
            callback = options;
            options = names || {};
            names = undefined;
        }
    }
    return {
        names,
        options,
        callback,
    };
}

export function isEmptyObject(obj: any) {
    return Object.keys(obj).length === 0;
}

export function hasRules(validate: any) {
    if (validate) {
        return validate.some((item: any) => item.rules && item.rules.length);
    }
    return false;
}

export function startsWith(str: string, prefix: string) {
    return str.lastIndexOf(prefix, 0) === 0;
}

export function supportRef(nodeOrComponent: any) {
    const type = isMemo(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;

    // Function component node
    if (typeof type === 'function' && !(type.prototype && type.prototype.render)) {
        return false;
    }

    // Class component
    if (typeof nodeOrComponent === 'function' && !(nodeOrComponent.prototype && nodeOrComponent.prototype.render)) {
        return false;
    }
    return true;
}
